import { CommonModule } from '@angular/common';
import { Component, HostBinding, OnInit, input, output, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import {
  MdwSwapAnimateComponent,
  MdwSwapTemplateDirective,
} from '@spaces-ui/animations/angular-css';
import { MdwButton } from '@spaces-ui/meadow/components/button';
import { MdwIcon } from '@spaces-ui/meadow/icons';
import { Check_Small, Close_Medium } from '@spaces-ui/meadow/icons/svgs';
import { EventUtils } from '@spaces-ui/utils';

/** `Notification` = red pill + accented label; `Count` = plain small primary text. */
export type ListItemBadgeStyle = 'Notification' | 'Count';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'nav ul li, menu ul li, ul[cdkListbox] li, [mdwListItem]',
  imports: [
    CommonModule,
    MdwIcon,
    RouterLink,
    RouterLinkActive,
    MdwButton,
    MdwSwapAnimateComponent,
    MdwSwapTemplateDirective,
  ],
  templateUrl: './list-item.html',
  styleUrl: './list-item.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.subdued]': 'subdued()',
  },
})
export class MdwListItem implements OnInit {
  public readonly icon = input<string>('');
  public readonly badge = input<string>();
  public readonly badgeStyle = input<ListItemBadgeStyle>('Notification');
  public readonly iconColor = input<string>();
  public readonly iconPresetColorNumber = input<number>(); // 1 - 24
  public readonly routerLink = input<string | string[]>('');
  public readonly routerLinkActive = input<string>('');
  public readonly href = input<string>('');
  public readonly disabled = input<boolean>(false);
  public readonly cdkMenuItemDisabled = input<boolean>(false);
  public readonly useCheckbox = input(false);
  public readonly iconSize = input<'medium' | 'small'>('medium');
  public readonly includeToggle = input(false);
  public readonly toggleChecked = input(false);
  public readonly includeHideOnHover = input(false);
  public readonly subdued = input(false);

  public readonly hide = output<MouseEvent>();

  protected iconColorClass = '';

  protected readonly icons = { Check_Small, Close_Medium };

  @HostBinding('class.has-icon')
  public get hasIcon(): boolean {
    return !!this.icon();
  }

  @HostBinding('class.accented')
  public get hasBadge(): boolean {
    return !!this.badge() && this.badgeStyle() === 'Notification';
  }

  @HostBinding('class.disabled')
  public get isDisabled(): boolean {
    return this.disabled() || this.cdkMenuItemDisabled();
  }

  public ngOnInit(): void {
    if (this.iconColor()) {
      this.iconColorClass = `color-${this.iconColor()}`;
    }
  }

  protected preventBubble(event: MouseEvent): void {
    EventUtils.preventBubble(event);
  }
}
